import { CheckboxFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";

const blockRemoveSidesMarginField = {
    displayName: "Remove Left and Right Margins",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
} as CheckboxFieldDefinition;

export const blockKeepSidesMarginForHighResField = {
    displayName: "Keep Left and Right Margins for Highest resolution",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
} as CheckboxFieldDefinition;

export default blockRemoveSidesMarginField;
